import React, { useState, useEffect } from "react";
import "../Styles/MainSection.css";
import leavsImg from "../assets/Header-Images/leavesImg.png";
import BigleavsImg from "../assets/Header-Images/1.png.png";
import logoSeal from "../assets/Header-Images/logo_ 2.png";
import mobileBg from "../assets/Header-Images/mobileBgImg.png"; // Mobile ke liye background

/* ✅ Background Image Imports */
import bg1 from "../assets/Header-Images/Group-23.png";
import bg2 from "../assets/Header-Images/barleyBgImg.jpg";
import bg3 from "../assets/Header-Images/fieldBgImg.jpg";
import bg4 from "../assets/Header-Images/spreadImg.jpg";

/* 🔹 Background images with their respective content */
const bgData = [
    {
        url: bg1,
        heading: `किसान का हाथ, रफ्तार के साथ`,
    },
    {
        url: bg2,
        heading: "नया दौर,नई खेती",
    },
    {
        url: bg3,
        heading: "खेती में प्रगति,हर दिन नई गति",
    },
    {
        url: bg4,
        heading: "खेत से,खलिहान तक",
    },
];

const textColors = {
    0: "#EEC044", 
    1: "#151106", 
    2: "#FFA500", 
    3: "#FFA500", 
};

const headingColors = {
    0: "#4BAF47", 
    1: "#4A5722", 
    2: "#228B22",
    3: "#4BAF47", 
};

const MainSection = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        console.log("Current Index:", currentIndex);
        console.log("Current Image URL:", bgData[currentIndex]?.url);
    }, [currentIndex]);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(true); // Fade out before changing image
            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % bgData.length);
                setFade(false); // Fade in after image change
            }, 1000); // 1s fade-out before image change
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <section
            className={`main-section ${fade ? "fade" : ""}`}
            style={{
                backgroundImage: `url(${isMobile ? mobileBg : bgData[currentIndex]?.url})`,
            }}
        >
            {/* 🔹 Top Text */}
            <p 
            className="top-text" 
            style={{ color: textColors[currentIndex] || "#000000" }} // Default Black if index not in object
        >
            Globe International Crop Science
        </p>

            {/* 🔹 Main Content */}
            <div className="main-content">
                <h2 style={{color:headingColors[currentIndex]} || '#4BAF47'}>
                    {bgData[currentIndex]?.heading.split(",").map((line, index) => (
                        <React.Fragment key={index}>
                            {line}
                            {index !== bgData[currentIndex]?.heading.split(",").length - 1 && <br />}
                        </React.Fragment>
                    ))}
                </h2>
                {/* <div className="icon-container">
                    <img src={leavsImg} alt="Organic Product" className="icon" />
                    <p className="icon-content">{bgData[currentIndex]?.text}</p>
                </div> */}
            </div>

            {/* 🔹 Logo Seal */}
            <div className="logo-seal">
                <img src={logoSeal} alt="Seal" />
            </div>

            {/* 🔹 Leaves Image (Right-Top Corner) */}
            <img src={BigleavsImg} alt="Leaves" className="leaves-image" />
        </section>
    );
};

export default MainSection;


//with all image carousal
// import React, { useState, useEffect } from "react";
// import "../Styles/MainSection.css";
// import leavsImg from "../assets/Header-Images/leavesImg.png";
// import BigleavsImg from "../assets/Header-Images/1.png.png";
// import logoSeal from "../assets/Header-Images/logo_ 2.png";
// import mobileBg from "../assets/Header-Images/mobileBgImg.png"; // Mobile ke liye background

// /* ✅ Background Image Imports */
// import bg1 from "../assets/Header-Images/Group-23.png";
// import bg2 from "../assets/Header-Images/barleyBgImg.jpg";
// import bg3 from "../assets/Header-Images/fieldBgImg.jpg";
// import bg4 from "../assets/Header-Images/spreadImg.jpg";

// /* 🔹 Background images with their respective content */
// const bgData = [
//     {
//         url: bg1,
//         heading: `किसान का हाथ, रफ्तार के साथ`,
//     },
//     {
//         url: bg2,
//         heading: "नया दौर,नई खेती",
//     },
//     {
//         url: bg3,
//         heading: "खेती में प्रगति,हर दिन नई गति",
//     },
//     {
//         url: bg4,
//         heading: "खेत से,खलिहान तक",
//     },
// ];

// const textColors = {
//     0: "#EEC044",
//     1: "#151106",
//     2: "#FFA500",
//     3: "#FFA500",
// };

// const headingColors = {
//     0: "#4BAF47",
//     1: "#4A5722",
//     2: "#228B22",
//     3: "#4BAF47",
// };

// const MainSection = () => {
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [fade, setFade] = useState(false);
//     const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

//     useEffect(() => {
//         console.log("Current Index:", currentIndex);
//         console.log("Current Image URL:", bgData[currentIndex]?.url);
//     }, [currentIndex]);

//     useEffect(() => {
//         const interval = setInterval(() => {
//             setFade(true); // Fade out before changing image
//             setTimeout(() => {
//                 setCurrentIndex((prevIndex) => (prevIndex + 1) % bgData.length);
//                 setFade(false); // Fade in after image change
//             }, 1000); // 1s fade-out before image change
//         }, 5000);

//         return () => clearInterval(interval);
//     }, []);

//     useEffect(() => {
//         const handleResize = () => {
//             setIsMobile(window.innerWidth <= 768);
//         };

//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     useEffect(() => {
//         const handleResize = () => {
//             setIsMobile(window.innerWidth <= 768);
//         };

//         window.addEventListener("resize", handleResize);
//         handleResize(); // Call initially

//         return () => window.removeEventListener("resize", handleResize);
//     }, []);


//     return (
//         <section
//             className={`main-section ${fade ? "fade" : ""}`}
//             style={{
//                 backgroundImage: `url(${isMobile ? bgData[currentIndex]?.url : bgData[currentIndex]?.url})`,
//             }}
//         >

//             {/* 🔹 Top Text */}
//             <p
//                 className="top-text"
//                 style={{ color: textColors[currentIndex] || "#000000" }} // Default Black if index not in object
//             >
//                 Globe International Crop Science
//             </p>

//             {/* 🔹 Main Content */}
//             <div className="main-content">
//                 <h2 style={{ color: headingColors[currentIndex] } || '#4BAF47'}>
//                     {bgData[currentIndex]?.heading.split(",").map((line, index) => (
//                         <React.Fragment key={index}>
//                             {line}
//                             {index !== bgData[currentIndex]?.heading.split(",").length - 1 && <br />}
//                         </React.Fragment>
//                     ))}
//                 </h2>
//                 {/* <div className="icon-container">
//                     <img src={leavsImg} alt="Organic Product" className="icon" />
//                     <p className="icon-content">{bgData[currentIndex]?.text}</p>
//                 </div> */}
//             </div>

//             {/* 🔹 Logo Seal */}
//             <div className="logo-seal">
//                 <img src={logoSeal} alt="Seal" />
//             </div>

//             {/* 🔹 Leaves Image (Right-Top Corner) */}
//             <img src={BigleavsImg} alt="Leaves" className="leaves-image" />
//         </section>
//     );
// };

// export default MainSection;

